import { Link } from "react-router-dom";
import { services } from "../content";

export function ServicesPage() {
  return (
    <main id="main-content" className="interior-world services-world">
      <section className="services-machine-hero">
        <div className="services-machine-copy">
          <p className="route-kicker" data-hero-support>Custom systems and automation</p>
          <h1>
            <span data-hero-line><span>Repeated work,</span></span>
            <span data-hero-line><span>made reliable.</span></span>
          </h1>
          <p data-hero-support>Automation, conversation AI, and custom tools shaped around your rules, exceptions, and team.</p>
          <a className="world-button" href="#service-spine" data-hero-support>Explore services</a>
        </div>
        <div className="services-machine-stage">
          <div className="machine-glow" aria-hidden="true" />
          <img src="/visuals/marky-services-machine.webp" alt="Marky operating a machine that turns tangled work into clear outputs" width="1672" height="941" fetchPriority="high" data-route-object />
        </div>
      </section>

      <section className="service-spine" id="service-spine">
        {services.map((service, index) => (
          <article className="service-chapter" key={service.title}>
            <div className="service-chapter-index" aria-hidden="true">0{index + 1}</div>
            <div className="service-chapter-copy" data-reveal>
              <h2>{service.title}</h2>
              <strong>{service.promise}</strong>
              <p>{service.body}</p>
            </div>
            <div className="service-chapter-output" data-reveal>
              {service.deliverables.map((item) => <span key={item}>{item}</span>)}
            </div>
          </article>
        ))}
      </section>

      <section className="service-symptoms">
        <h2 data-reveal>The brief often arrives as a sentence.</h2>
        <div className="service-symptom-track" data-route-pan>
          <blockquote>“Our inbox has become the workflow.”</blockquote>
          <blockquote>“The team still asks one person where everything is.”</blockquote>
          <blockquote>“We tried automation, but nobody trusts it.”</blockquote>
          <blockquote>“Customers message us everywhere and context gets lost.”</blockquote>
        </div>
      </section>

      <section className="service-process">
        <div className="service-process-media" data-clip-reveal>
          <img src="/portfolio/hello-marky-workflow-session.webp" alt="Two business operators mapping a real workflow" loading="lazy" data-parallax />
        </div>
        <div className="service-process-copy">
          <h2 data-reveal>We design around the real day.</h2>
          <ol>
            <li data-reveal><strong>Understand the strain.</strong><span>Find the repeated task, hidden judgement, and handoff that creates it.</span></li>
            <li data-reveal><strong>Choose the lightest path.</strong><span>Use the simplest useful combination of product, integration, automation, and AI.</span></li>
            <li data-reveal><strong>Build recovery in.</strong><span>Make review, failure states, boundaries, and human takeover part of the system.</span></li>
            <li data-reveal><strong>Improve it in use.</strong><span>Watch the real workflow and refine what no diagram could predict.</span></li>
          </ol>
        </div>
      </section>

      <section className="interior-close">
        <img src="/brand/marky-dark.svg" alt="" aria-hidden="true" />
        <h2>The repeated thing is usually the right place to start.</h2>
        <Link className="world-button" to="/contact">Tell us what feels heavy <span aria-hidden="true">↗</span></Link>
      </section>
    </main>
  );
}
